// Thin helper that fetches the fridge's menu (including shelfLife per vendItem)
// and returns it as a { vendItemName: shelfLifeDays } map. Scoped to this page
// because the main GraphQL.js doesn't track shelf life elsewhere.

import { GetMenuShelfLife } from '../../libs/GraphQL';

async function getShelfLifeMap(locationId) {
  const items = await GetMenuShelfLife(locationId);
  const map = {};
  (items || []).forEach((i) => {
    if (i && i.id && typeof i.shelfLife === 'number') {
      map[i.id] = i.shelfLife;
    }
  });
  return map;
}

export default { getShelfLifeMap };
